<template>
    <v-dialog v-model="dialog" width="500" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="semester_schoolyear"
                                label="Semester and Schoolyear"
                                :rules="[formRules.required]"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :items="semester_schoolyear_data"
                                :item-title="getItemTitle"
                                item-value="id"
                                return-object
                                >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Copy" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            programId: null,
            semester_schoolyear: null,
            semester_schoolyear_data: [],
        }
     },
     methods: {
        async init(){
            this.dialog = true
            this.dialog_title = 'Copy RDE Unit Load'
            this.dialog_sub_title = 'Select the semester and schoolyear to copy the RDE Unit Load from.'

            let res = await this.axiosCall('/semester-schoolyear/findAllExceptId/' + this.$store.state.semester_schoolyear.id, 'get', null, true)
            if(res.data){
                this.semester_schoolyear_data = res.data
            }
        },
        getItemTitle(item) {
            return `${item.semester} - ${item.schoolyear}${item.isActive ? " (Active)" : ""}`;
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()
            
            if(valid){
                this.loading = true
                let data = {
                    programId: this.programId,
                    prevSemesterSchoolyear: parseInt(this.semester_schoolyear.id),
                    currentSemesterSchoolyear: parseInt(this.$store.state.semester_schoolyear.id)
                }
                let res = await this.axiosCall('/rep-unit-load/copyFromPreviousSemester', 'post', data, true)
                if(res.data.status === 200){
                    this.loading = false
                    showSnackbar(res.data.message)
                    this.$emit('refresh')
                    this.closeDialog()
                }
                else if(res.data.status === 404){
                    this.loading = false
                    showSnackbar(res.data.message)
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>